import React, { useState } from 'react';

import { Button } from '@host/components/NewUI/ComponentsLibrary';

import Layout from './components/Layout';
import PortalBackButton from './components/PortalBackButton';
import PortalCard from './components/PortalCard';
import PortalFooter from './components/PortalFooter';
import { font, palette } from './styles';
import { usePortalCompact } from './usePortalCompact';

interface Props {
  onBack: () => void;
  onConfirm: (notes: string) => Promise<void>;
}

const OfferDecline: React.FC<Props> = ({ onBack, onConfirm }) => {
  const [notes, setNotes] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const compact = usePortalCompact();

  const handleConfirm = async () => {
    setSubmitting(true);
    setError(null);
    try {
      await onConfirm(notes);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to decline');
      setSubmitting(false);
    }
  };

  return (
    <Layout title="Decline offer">
      <PortalCard>
        <div style={{ marginBottom: 24 }}>
          <PortalBackButton label="Back to offer" onClick={onBack} />
        </div>

        <p style={{ color: palette.bodyNeutral, fontSize: 14, margin: '0 0 16px' }}>
          Declining will notify the recruiter. This cannot be undone.
        </p>

        <label
          htmlFor="decline-reason"
          style={{
            display: 'block',
            fontSize: 16,
            fontWeight: 400,
            color: palette.bodyNeutral,
            marginBottom: 8
          }}
        >
          Reason (optional)
          <textarea
            id="decline-reason"
            onChange={(e) => setNotes(e.target.value)}
            rows={4}
            value={notes}
            style={{
              display: 'block',
              width: '100%',
              boxSizing: 'border-box',
              marginTop: 8,
              padding: 12,
              fontFamily: font,
              // iOS Safari zooms the page when focusing a field under 16px.
              fontSize: compact ? 16 : 14,
              border: `1px solid ${palette.inputBorder}`,
              borderRadius: 6
            }}
          />
        </label>

        {error ? (
          <p style={{ color: palette.warning, fontSize: 14, marginTop: 16 }}>{error}</p>
        ) : null}
      </PortalCard>

      <PortalFooter>
        <Button buttonVariant="text" id="portal-cancel-decline-button" onClick={onBack}>
          Cancel
        </Button>
        <Button
          buttonColor="red"
          buttonVariant="primary"
          disabled={submitting}
          id="portal-confirm-decline-button"
          onClick={handleConfirm}
        >
          {submitting ? 'Declining…' : 'Decline offer'}
        </Button>
      </PortalFooter>
    </Layout>
  );
};

export default OfferDecline;
